// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3mlNK","log":"ModalInventoryLogs_log__27NRm","date":"ModalInventoryLogs_date__21oSQ","userName":"ModalInventoryLogs_userName__3c6tI"};